import React from "react";
import AutocompleteListbox from "@mui/joy/AutocompleteListbox";

const ListboxComponent = (props) => (
  <AutocompleteListbox
    {...props}
    variant="plain"
    size="sm"
    sx={{
      "--List-padding": "0px",
      "--List-radius": "0px",
      "--ListItem-paddingX": "8px",
      "--ListItem-paddingY": "8px",
      minWidth: "100%",
    }}
  />
);

export default ListboxComponent;
